import { Box, Flex, Stack } from '@mantine/core';

import DMText from '@/components/DMText';
import DiscoveryContentRelatedVerticalCard from '@/features/Discovery/components/DiscoveryContentRelatedVerticalCard';
import Image from 'next/image';
import { emojiSource } from '@/utils/utils';
import themeVariables from '@/styles/themeVariables';
import { useGetRelatedContent } from '../hook/api';
import { useGoContentDetail } from '@/features/Discovery/hook/useContentListMethod';

const SimilarContents = () => {
  const { data } = useGetRelatedContent();

  const { goDetailRelatedContent } = useGoContentDetail();

  if (data?.contents?.length === 0) return null;
  return (
    <>
      <Flex mb={16} gap={8} align={'center'}>
        <DMText size={16} weight={700} dColor={themeVariables.darkMode.normal}>
          좋아하실 글을 골라봤어요
        </DMText>
        <Image
          width={18}
          height={18}
          src={emojiSource('1f440', 'apple')}
          alt="emoji"
        />
      </Flex>
      <Stack spacing={18}>
        {data?.contents?.map((content, index) => (
          <Box key={index} onClick={goDetailRelatedContent(content)}>
            <DiscoveryContentRelatedVerticalCard content={content} />
          </Box>
        ))}
      </Stack>
    </>
  );
};

export default SimilarContents;
